export const profile = {
  name: "Prathamesh Shete",
  username: "prathamesh_shete",
  title: "AI/ML Engineer & Full-Stack Developer",
  bio: [
    "AI Engineer with a background in Electrical Engineering, building intelligent systems that solve real problems.",
    "Specialized in LLMs, RAG pipelines, and production AI using PyTorch, TensorFlow, and Hugging Face.",
    "Past work includes 'Chat with Krishna', an AI guidance platform based on the Bhagavad Gita, and 'Chat with Docs', a real-time tool for healthcare professionals."
  ],
  expertise: ["LLM", "RAG Systems", "LangChain", "FastAPI", "React", "Docker", "AWS", "Python"],
  status: "Open to opportunities — Full-time AI/ML Engineering roles",
  resumeUrl: "/resume.pdf"
};
